import React from 'react';
import './TermsConditions.scss';

function TermsConditions() {
  return (
    <div className="TermsConditions">
      <h2>Terms and Conditions</h2>
      <div className="tnc-container">
        <h3>Payment</h3>
        <ul>
          <li>
            By booking or using a service you indicate that you have read, understood and accepted
            these terms and conditions.
          </li>
          <li>
            A Non-refundable/non-transferable booking fee of $100 is required to secure your
            event/wedding date.
          </li>
          <li>
            The event/wedding date booking will not be secured until a booking fee is paid. In some
            cases, the booking fee may need to be paid before your trial to ensure your wedding date
            is secured.
          </li>
          <li>
            For single in studio bookings a non-refundable/non-transferable booking fee of $50 is
            required to secure your booking.
          </li>
          <li>You agree to pay the balance of your in studio service by cash.</li>
          <li>Minimum call out of 4 makeup services is required for travel.</li>
          <li>
            Final payment of your invoice is due 2 weeks prior to your wedding or event date when
            paying via bank transfer or on the wedding or event day when paying by cash.
          </li>
          <li>
            When paying via cash you agree to have all money owed ready to hand over by the end of
            the service.
          </li>
          <li>
            Payment for extra services is due on the day and is payable in cash (e.g. extra people).
          </li>
          <li>
            A 15% surcharge will be applied to the total for early morning start times of 6.30am or
            earlier.
          </li>
          <li>Bookings made on public holidays will incur a 15% surcharge to the total.</li>
          <li>Travel fees apply and will be quoted on enquiry.</li>
          <li>
            You will need to ensure that parking is readily available at the location. Parking fees
            may apply and are payable upon arrival by cash.
          </li>
        </ul>
        <h3>Cancellations and Changes</h3>
        <ul>
          <li>
            Any reductions in the booked number of people for you wedding will still need to be paid
            for in full, if less than 1 month's notice is given. If your booking is for an event
            only, less than 2 week's notice will require full payment. This is to prevent
            cancellations close to or on the date which will otherwise result in a loss of other
            potential work that could have been booked.
          </li>
          <li>
            If reductions in numbers fall below minimum call out you will be required to travel to
            my studio for your services or pay the minimum services required for travel.
          </li>
          <li>
            Please notify me of any location changes as soon as possible, this may change your quote
            due to travel fee's/early start etc. I will send you a revised quote if this is the
            case.
          </li>
        </ul>
        <h3>Late Arrivals</h3>
        <li>
          On occasion I may have other bookings before or after your event, it is imperative that
          you and your party are on time to receive their services. For each 15 minutes that I am
          held up I will charge $25. This will be paid immediately once the job is done via cash or
          bank transfer.
        </li>
        <li>
          If you are late to your appointment we may need to shorten the length of your appointment
          or change your service.
        </li>
        <li>
          If you are more than 15 minutes late to your in studio appointment we may at our absolute
          discretion cancel your appointment and your booking fee will nt be able to be used at a
          later date.
        </li>
        <h3>Miscellaneous</h3>
        <ul>
          <li>
            At the trial you will be given instructions on what is required regarding hair and
            makeup preparation during the weeks/months before and on the day. If this advice is not
            followed then additional costs may be charged on the day (e.g. if hair is still wet and
            I need to do a full blow dry prior to an upstyle/downstyle)
          </li>
          <li>
            You acknowledge that I may use your photographs on my website, social media portfolio
            and promotional material.
          </li>
          <li>
            You will ensure that my place of work on your behalf is a smoke free zone to ensure that
            myself and my working kit are kept smoke free and ready for my next clients. I will
            refuse to work in a smoking environment.
          </li>
          <h3>Changes Beyond Our Control</h3>
          <li>
            If a significant change is made for reasons beyond our control, then, to the fullest
            extent permitted by law, but not otherwise, we are not liable to compensate you. These
            include war, threat of war, riots, civil disturbances, terrorist activity, industrial
            disputes, natural and nuclear disaster, fire, epidemics, pandemics, health risks,
            changes due to rescheduling or cancellation of event, closed or congested airports or
            ports, act of government or public authorities, or other circumstances amounting to
            force majeure, and/or acts of God.
          </li>
          <li>
            Booking fees will be made transferable if any of the above occurs, subject to
            availability. Booking fees will remain non-refundable.
          </li>
        </ul>
      </div>
    </div>
  );
}

export default TermsConditions;
